'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../../../../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./BoardImageUploadIcon.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var BoardImageUploadIcon = function BoardImageUploadIcon() {
    return _react2.default.createElement(
        'div',
        { className: 'BoardImageUploadIcon' },
        _react2.default.createElement(_Icon2.default, { name: 'image-form-upload' })
    );
};

// Styles
// Lib


BoardImageUploadIcon.propTypes = {};

exports.default = BoardImageUploadIcon;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/tabContent/imagePicker/BoardImageUploadIcon.js
// module id = 2245
// module chunks = 0